import { AuthService } from 'src/app/auth/auth.service';
import { CompanyInfo } from 'src/app/buyer/invoice-operation/invoice-operation-services/invoice-operation.interface';
import {
  CompanyDropdownInfo,
  MultiBuyerCmp,
} from '../../interfaces/company.interface';
import { MultiBuyerSession } from './multi-buyer-session';

export class MultiBuyerIdentity {
  constructor(private readonly _auth: AuthService) {}

  async fetchBuyersIds(
    multiBuyerSession: MultiBuyerSession
  ): Promise<number[]> {
    if (!this._auth.isLoggedInAsMultiBuyer()) {
      return [];
    }

    const result = await multiBuyerSession
      .buyers(this._originId)
      .then((companies) => this._toCompanyDropdownInfo(companies));

    return new BuyerCollection(result).ids;
  }

  private get _originId(): number {
    const selected = this._auth.selectedMultiBuyerCompany;
    return (selected?.parentCompany || this._auth.userCompanyId)!;
  }

  get defaultSelectionId(): number | undefined {
    return this._auth.selectedMultiBuyerCompany?.id;
  }

  private _toCompanyDropdownInfo(
    companies: MultiBuyerCmp[]
  ): CompanyDropdownInfo[] {
    return companies.map(
      (company) =>
        ({ name: company.nm, id: company.id } as unknown as CompanyDropdownInfo)
    );
  }
}

export class BuyerCollection {
  constructor(private readonly _dropdownItens: CompanyDropdownInfo[] = []) {}

  dropdownItems(targetId: number): CompanyInfo[] {
    const found = this.find(targetId);
    return [found];
  }

  get ids(): number[] {
    return this._dropdownItens.map((buyer) => Number(buyer.id));
  }

  has(targetId: number): boolean {
    return this._dropdownItens.some(
      (buyer) => Number(buyer.id) === Number(targetId)
    );
  }

  get hasItems(): boolean {
    return this._dropdownItens && this._dropdownItens.length > 0;
  }

  find(targetId: number): CompanyDropdownInfo {
    const found = this._dropdownItens.find(
      (buyer) => Number(buyer.id) === Number(targetId)
    );
    if (!found) {
      throw new Error(`Company: ${targetId} not found`);
    }
    return found;
  }
}
